module.exports = __webpack_public_path__ + "img/back.79ad6a1b.png";